import { apiGet, ApiError } from './http-client';

/** Ответ GET /api/v1/subscriptions/my-subscriptions/for-slot/{slot_id} */
export type ForSlotSubscription = {
  id: number;
  plan_name: string;
  plan_type: string;
  visits_remaining: number | null;
  balance_remaining: string | number | null;
  valid_until: string | null;
  branch_id: number | null;
  branch_name: string | null;
};

export async function fetchSubscriptionsForSlot(
  slotId: number,
  accessToken: string
): Promise<ForSlotSubscription[]> {
  try {
    return await apiGet<ForSlotSubscription[]>(
      `/api/v1/subscriptions/my-subscriptions/for-slot/${slotId}`,
      { optional: 1 },
      { accessToken }
    );
  } catch (e) {
    // Старый backend/выключенный модуль: абонементов нет — это не ошибка оплаты/записи.
    if (e instanceof ApiError && e.status === 403) return [];
    throw e;
  }
}
